// /**
//  * src/store/slices/settingsSlice.js
//  */
// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import settingsService from "../../services/settingsService";

// const extractError = (error) =>
//   error?.response?.data?.message ||
//   error?.message ||
//   "Something went wrong.";

// // ── Thunks ──────────────────────────────────────────────────────────

// export const fetchUsers = createAsyncThunk(
//   "settings/fetchUsers",
//   async ({ page, search } = {}, { rejectWithValue }) => {
//     try {
//       const data = await settingsService.getUsers({ page, search });
//       return data; // { data: [...], pagination }
//     } catch (error) {
//       return rejectWithValue(extractError(error));
//     }
//   }
// );

// export const fetchArchivedUsers = createAsyncThunk(
//   "settings/fetchArchivedUsers",
//   async ({ page, search } = {}, { rejectWithValue }) => {
//     try {
//       const data = await settingsService.getArchivedUsers({ page, search });
//       return data;
//     } catch (error) {
//       return rejectWithValue(extractError(error));
//     }
//   }
// );

// export const fetchUserById = createAsyncThunk(
//   "settings/fetchUserById",
//   async (userId, { rejectWithValue }) => {
//     try {
//       const data = await settingsService.getUserById(userId);
//       return data.data; // full user object
//     } catch (error) {
//       return rejectWithValue(extractError(error));
//     }
//   }
// );

// export const inviteUser = createAsyncThunk(
//   "settings/inviteUser",
//   async (userData, { rejectWithValue }) => {
//     try {
//       const data = await settingsService.inviteUser(userData);
//       return data;
//     } catch (error) {
//       return rejectWithValue(extractError(error));
//     }
//   }
// );

// export const toggleUser = createAsyncThunk(
//   "settings/toggleUser",
//   async (userId, { rejectWithValue }) => {
//     try {
//       const data = await settingsService.toggleUser(userId);
//       return data.data; // { _id, isDisabled, status }
//     } catch (error) {
//       return rejectWithValue(extractError(error));
//     }
//   }
// );

// export const restoreUser = createAsyncThunk(
//   "settings/restoreUser",
//   async (userId, { rejectWithValue }) => {
//     try {
//       const data = await settingsService.restoreUser(userId);
//       return userId; // return userId to remove from archived list
//     } catch (error) {
//       return rejectWithValue(extractError(error));
//     }
//   }
// );

// export const deleteUser = createAsyncThunk(
//   "settings/deleteUser",
//   async (userId, { rejectWithValue }) => {
//     try {
//       await settingsService.deleteUser(userId);
//       return userId; // return userId to remove from list
//     } catch (error) {
//       return rejectWithValue(extractError(error));
//     }
//   }
// );

// // ── Initial State ────────────────────────────────────────────────────

// const initialState = {
//   // Resources list
//   resources: [],
//   resPagination: {},
//   isLoadingResources: false,
//   resourcesError: null,

//   // Archived list
//   archived: [],
//   archPagination: {},
//   isLoadingArchived: false,
//   archivedError: null,

//   // Single user detail (SidePanel)
//   selectedUser: null,
//   isLoadingUser: false,
//   userError: null,

//   // Invite
//   isInviting: false,
//   inviteError: null,
//   inviteSuccess: false,

//   // Toggle
//   isToggling: false,
//   toggleError: null,

//   // Restore
//   isRestoring: false,
//   restoreError: null,

//   // Delete
//   isDeleting: false,
//   deleteError: null,
// };

// // ── Slice ────────────────────────────────────────────────────────────

// const settingsSlice = createSlice({
//   name: "settings",
//   initialState,

//   reducers: {
//     clearInviteState: (state) => {
//       state.inviteError = null;
//       state.inviteSuccess = false;
//     },
//     clearSelectedUser: (state) => {
//       state.selectedUser = null;
//       state.userError = null;
//     },
//     clearSettingsErrors: (state) => {
//       state.resourcesError = null;
//       state.archivedError = null;
//       state.userError = null;
//       state.inviteError = null;
//       state.toggleError = null;
//       state.restoreError = null;
//       state.deleteError = null;
//     },
//   },

//   extraReducers: (builder) => {
//     // ── fetchUsers ────────────────────────────
//     builder
//       .addCase(fetchUsers.pending, (state) => {
//         state.isLoadingResources = true;
//         state.resourcesError = null;
//       })
//       .addCase(fetchUsers.fulfilled, (state, action) => {
//         state.isLoadingResources = false;
//         state.resources = action.payload.data;
//         state.resPagination = action.payload.pagination;
//       })
//       .addCase(fetchUsers.rejected, (state, action) => {
//         state.isLoadingResources = false;
//         state.resourcesError = action.payload;
//       });

//     // ── fetchArchivedUsers ────────────────────
//     builder
//       .addCase(fetchArchivedUsers.pending, (state) => {
//         state.isLoadingArchived = true;
//         state.archivedError = null;
//       })
//       .addCase(fetchArchivedUsers.fulfilled, (state, action) => {
//         state.isLoadingArchived = false;
//         state.archived = action.payload.data;
//         state.archPagination = action.payload.pagination;
//       })
//       .addCase(fetchArchivedUsers.rejected, (state, action) => {
//         state.isLoadingArchived = false;
//         state.archivedError = action.payload;
//       });

//     // ── fetchUserById ─────────────────────────
//     builder
//       .addCase(fetchUserById.pending, (state) => {
//         state.isLoadingUser = true;
//         state.userError = null;
//         state.selectedUser = null;
//       })
//       .addCase(fetchUserById.fulfilled, (state, action) => {
//         state.isLoadingUser = false;
//         state.selectedUser = action.payload;
//       })
//       .addCase(fetchUserById.rejected, (state, action) => {
//         state.isLoadingUser = false;
//         state.userError = action.payload;
//       });

//     // ── inviteUser ────────────────────────────
//     builder
//       .addCase(inviteUser.pending, (state) => {
//         state.isInviting = true;
//         state.inviteError = null;
//         state.inviteSuccess = false;
//       })
//       .addCase(inviteUser.fulfilled, (state) => {
//         state.isInviting = false;
//         state.inviteSuccess = true;
//       })
//       .addCase(inviteUser.rejected, (state, action) => {
//         state.isInviting = false;
//         state.inviteError = action.payload;
//       });

//     // ── toggleUser ────────────────────────────
//     builder
//       .addCase(toggleUser.pending, (state) => {
//         state.isToggling = true;
//         state.toggleError = null;
//       })
//       .addCase(toggleUser.fulfilled, (state, action) => {
//         state.isToggling = false;
//         // Update the user's status in the resources list locally
//         const { _id, status } = action.payload;
//         state.resources = state.resources.map((u) =>
//           u._id === _id ? { ...u, status } : u
//         );
//       })
//       .addCase(toggleUser.rejected, (state, action) => {
//         state.isToggling = false;
//         state.toggleError = action.payload;
//       });

//     // ── restoreUser ───────────────────────────
//     builder
//       .addCase(restoreUser.pending, (state) => {
//         state.isRestoring = true;
//         state.restoreError = null;
//       })
//       .addCase(restoreUser.fulfilled, (state, action) => {
//         state.isRestoring = false;
//         // Remove from archived list locally
//         state.archived = state.archived.filter(
//           (u) => u._id !== action.payload
//         );
//       })
//       .addCase(restoreUser.rejected, (state, action) => {
//         state.isRestoring = false;
//         state.restoreError = action.payload;
//       });

//     // ── deleteUser ────────────────────────────
//     builder
//       .addCase(deleteUser.pending, (state) => {
//         state.isDeleting = true;
//         state.deleteError = null;
//       })
//       .addCase(deleteUser.fulfilled, (state, action) => {
//         state.isDeleting = false;
//         // Remove from archived list locally
//         state.archived = state.archived.filter(
//           (u) => u._id !== action.payload
//         );
//       })
//       .addCase(deleteUser.rejected, (state, action) => {
//         state.isDeleting = false;
//         state.deleteError = action.payload;
//       });
//   },
// });

// export const {
//   clearInviteState,
//   clearSelectedUser,
//   clearSettingsErrors,
// } = settingsSlice.actions;

// export default settingsSlice.reducer;
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import settingsService from "../../services/settingsService";

const extractError = (error) =>
  error?.response?.data?.message ||
  error?.message ||
  "Something went wrong.";

const ROLE_OVERRIDES_KEY = "qwickhub.settings.roleOverrides";

const loadRoleOverrides = () => {
  if (typeof window === "undefined") return {};
  try {
    return JSON.parse(window.localStorage.getItem(ROLE_OVERRIDES_KEY)) || {};
  } catch {
    return {};
  }
};

const saveRoleOverrides = (overrides) => {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(ROLE_OVERRIDES_KEY, JSON.stringify(overrides));
};

const mergeRoleOverride = (user, overrides) =>
  user?._id && overrides[user._id] ? { ...user, ...overrides[user._id] } : user;

const mergeRoleOverrides = (users, overrides) =>
  Array.isArray(users)
    ? users.map((user) => mergeRoleOverride(user, overrides))
    : [];

// ── Thunks ──────────────────────────────────────────────────────────

export const fetchUsers = createAsyncThunk(
  "settings/fetchUsers",
  async ({ page, search } = {}, { rejectWithValue }) => {
    try {
      const data = await settingsService.getUsers({ page, search });
      return data;
    } catch (error) {
      return rejectWithValue(extractError(error));
    }
  },
);

export const fetchArchivedUsers = createAsyncThunk(
  "settings/fetchArchivedUsers",
  async ({ page, search } = {}, { rejectWithValue }) => {
    try {
      const data = await settingsService.getArchivedUsers({ page, search });
      return data;
    } catch (error) {
      return rejectWithValue(extractError(error));
    }
  },
);

export const fetchUserById = createAsyncThunk(
  "settings/fetchUserById",
  async (userId, { rejectWithValue }) => {
    try {
      const data = await settingsService.getUserById(userId);
      return data.data;
    } catch (error) {
      return rejectWithValue(extractError(error));
    }
  },
);

export const inviteUser = createAsyncThunk(
  "settings/inviteUser",
  async (userData, { rejectWithValue }) => {
    try {
      const data = await settingsService.inviteUser(userData);
      return data;
    } catch (error) {
      return rejectWithValue(extractError(error));
    }
  },
);

export const toggleUser = createAsyncThunk(
  "settings/toggleUser",
  async (userId, { rejectWithValue }) => {
    try {
      const data = await settingsService.toggleUser(userId);
      return data.data;
    } catch (error) {
      return rejectWithValue(extractError(error));
    }
  },
);

export const restoreUser = createAsyncThunk(
  "settings/restoreUser",
  async (userId, { rejectWithValue }) => {
    try {
      await settingsService.restoreUser(userId);
      return userId;
    } catch (error) {
      return rejectWithValue(extractError(error));
    }
  },
);

export const deleteUser = createAsyncThunk(
  "settings/deleteUser",
  async (userId, { rejectWithValue }) => {
    try {
      await settingsService.deleteUser(userId);
      return userId;
    } catch (error) {
      return rejectWithValue(extractError(error));
    }
  },
);

export const fetchProjectsWithAccess = createAsyncThunk(
  "settings/fetchProjectsWithAccess",
  async (_, { rejectWithValue }) => {
    try {
      const data = await settingsService.getProjectsWithAccess();
      return data;
    } catch (error) {
      return rejectWithValue(extractError(error));
    }
  },
);

export const updateUserRole = createAsyncThunk(
  "settings/updateUserRole",
  async ({ userId, role, designation, specialization }, { rejectWithValue }) => {
    try {
      const data = await settingsService.updateUserRole(userId, {
        role,
        designation,
        specialization,
      });
      return data.data;
    } catch (error) {
      return rejectWithValue(extractError(error));
    }
  }
);

const initialState = {
  resources: [],
  resPagination: {},
  isLoadingResources: false,
  resourcesError: null,

  archived: [],
  archPagination: {},
  isLoadingArchived: false,
  archivedError: null,

  selectedUser: null,
  isLoadingUser: false,
  userError: null,

  isInviting: false,
  inviteError: null,
  inviteSuccess: false,

  isToggling: false,
  toggleError: null,

  isRestoring: false,
  restoreError: null,

  // Delete
  isDeleting: false,
  deleteError: null,

  projects: [],
  isLoadingProjects: false,
  projectsError: null,

  isUpdatingRole: false,
  updateRoleError: null,
  roleOverrides: loadRoleOverrides(),
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,

  reducers: {
    clearInviteState: (state) => {
      state.inviteError = null;
      state.inviteSuccess = false;
    },
    clearSelectedUser: (state) => {
      state.selectedUser = null;
      state.userError = null;
    },
    clearSettingsErrors: (state) => {
      state.resourcesError = null;
      state.archivedError = null;
      state.userError = null;
      state.inviteError = null;
      state.toggleError = null;
      state.restoreError = null;
      state.deleteError = null;
      state.updateRoleError = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.isLoadingResources = true;
        state.resourcesError = null;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.isLoadingResources = false;
        state.resources = mergeRoleOverrides(
          action.payload.data,
          state.roleOverrides,
        );
        state.resPagination = action.payload.pagination;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.isLoadingResources = false;
        state.resourcesError = action.payload;
      });

    builder
      .addCase(fetchArchivedUsers.pending, (state) => {
        state.isLoadingArchived = true;
        state.archivedError = null;
      })
      .addCase(fetchArchivedUsers.fulfilled, (state, action) => {
        state.isLoadingArchived = false;
        state.archived = action.payload.data;
        state.archPagination = action.payload.pagination;
      })
      .addCase(fetchArchivedUsers.rejected, (state, action) => {
        state.isLoadingArchived = false;
        state.archivedError = action.payload;
      });

    builder
      .addCase(fetchUserById.pending, (state) => {
        state.isLoadingUser = true;
        state.userError = null;
        state.selectedUser = null;
      })
      .addCase(fetchUserById.fulfilled, (state, action) => {
        state.isLoadingUser = false;
        state.selectedUser = mergeRoleOverride(
          action.payload,
          state.roleOverrides,
        );
      })
      .addCase(fetchUserById.rejected, (state, action) => {
        state.isLoadingUser = false;
        state.userError = action.payload;
      });

    builder
      .addCase(inviteUser.pending, (state) => {
        state.isInviting = true;
        state.inviteError = null;
        state.inviteSuccess = false;
      })
      .addCase(inviteUser.fulfilled, (state) => {
        state.isInviting = false;
        state.inviteSuccess = true;
      })
      .addCase(inviteUser.rejected, (state, action) => {
        state.isInviting = false;
        state.inviteError = action.payload;
      });

    builder
      .addCase(toggleUser.pending, (state) => {
        state.isToggling = true;
        state.toggleError = null;
      })
      .addCase(toggleUser.fulfilled, (state, action) => {
        state.isToggling = false;
        const { _id, status } = action.payload;
        state.resources = state.resources.map((u) =>
          u._id === _id ? { ...u, status } : u,
        );
      })
      .addCase(toggleUser.rejected, (state, action) => {
        state.isToggling = false;
        state.toggleError = action.payload;
      });

    builder
      .addCase(restoreUser.pending, (state) => {
        state.isRestoring = true;
        state.restoreError = null;
      })
      .addCase(restoreUser.fulfilled, (state, action) => {
        state.isRestoring = false;
        // Remove from archived list locally
        state.archived = state.archived.filter(
          (u) => u._id !== action.payload
        );
      })
      .addCase(restoreUser.rejected, (state, action) => {
        state.isRestoring = false;
        state.restoreError = action.payload;
      });

    builder
      .addCase(deleteUser.pending, (state) => {
        state.isDeleting = true;
        state.deleteError = null;
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.isDeleting = false;
        // Remove from archived list locally
        state.archived = state.archived.filter(
          (u) => u._id !== action.payload
        );
      })
      .addCase(deleteUser.rejected, (state, action) => {
        state.isDeleting = false;
        state.deleteError = action.payload;
      })
      // ── fetchProjectsWithAccess ─────────────

      .addCase(fetchProjectsWithAccess.pending, (state) => {
        state.isLoadingProjects = true;
        state.projectsError = null;
      })
      .addCase(fetchProjectsWithAccess.fulfilled, (state, action) => {
        state.isLoadingProjects = false;
        state.projects = action.payload.data || [];
      })
      .addCase(fetchProjectsWithAccess.rejected, (state, action) => {
        state.isLoadingProjects = false;
        state.projectsError = action.payload;
      });

    builder
      .addCase(updateUserRole.pending, (state) => {
        state.isUpdatingRole = true;
        state.updateRoleError = null;
      })
      .addCase(updateUserRole.fulfilled, (state, action) => {
        state.isUpdatingRole = false;
        const updated = action.payload;
        const roleFields = {
          role: updated.role,
          designation: updated.designation,
          specialization: updated.specialization,
        };
        state.roleOverrides[updated._id] = roleFields;
        saveRoleOverrides(state.roleOverrides);
        state.resources = state.resources.map((u) =>
          u._id === updated._id ? { ...u, ...updated, ...roleFields } : u
        );
        if (state.selectedUser?._id === updated._id) {
          state.selectedUser = { ...state.selectedUser, ...updated, ...roleFields };
        }
      })
      .addCase(updateUserRole.rejected, (state, action) => {
        state.isUpdatingRole = false;
        state.updateRoleError = action.payload;
      });
  },
});

export const { clearInviteState, clearSelectedUser, clearSettingsErrors } =
  settingsSlice.actions;

export default settingsSlice.reducer;
